export default __webpack_public_path__ + "static/media/home-426x607.4734fbcf.jpg";